/**
 * coastlines.ts
 *
 * Loads the real Natural Earth 110m coastline vectors already bundled with
 * this repository (Natural Earth data is public domain) and converts them
 * into flat [lon, lat] polylines for rendering as a thin reference overlay
 * on the 3D globe, so continents are recognizable even while terrain
 * elevation itself is still a synthetic placeholder.
 */

import { feature } from "topojson-client";
import type { Topology, GeometryCollection } from "topojson-specification";
import type { FeatureCollection, LineString } from "geojson";

export type LonLatPolyline = Array<[number, number]>;

export async function loadCoastlinePolylines(): Promise<LonLatPolyline[]> {
  const response = await fetch("/data/earth-topo-110m.json");
  if (!response.ok) {
    throw new Error(`Failed to load coastline data: HTTP ${response.status}`);
  }
  const topology = (await response.json()) as Topology;
  const coastlineObject = topology.objects["coastline_110m"] as GeometryCollection;
  const collection = feature(topology, coastlineObject) as unknown as FeatureCollection<LineString>;

  return collection.features.map((f) => f.geometry.coordinates as LonLatPolyline);
}
